export default __webpack_public_path__ + "static/media/b_aimingHigh_small.9965d255.png";